import { Box, useTheme } from '@mui/material';
import { PageHero } from '../components/ds';
import DocsBody from '../components/Docs/DocsBody.jsx';

/**
 * Documentation page (#1064): the full-page reading view at /docs. Reuses the
 * shared DocsBody renderer (left sticky table of contents + sections); the same
 * content also powers the dockable reference panel (components/Docs/DocsDock).
 *
 * Static reference content, no data load - isAuthReady is accepted for parity
 * with the other routed pages but unused.
 */
const Documentation = () => {
  const { ds } = useTheme();

  return (
    <Box>
      <PageHero
        label="Help"
        value="Knowledge Base"
        context="How BudgetRecon works, and how to get the most out of it"
      />
      <Box sx={{ mt: `${ds.space[8]}px` }}>
        <DocsBody variant="page" />
      </Box>
    </Box>
  );
};

export default Documentation;
